import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import {rootRouteRefPipelines, rootRouteRefVersions, rootRouteRefReports, rootRouteRefReleases} from './routes';

export const tonkeanCircleciPluginPlugin = createPlugin({
  id: 'tonkean-circleci-plugin',
  routes: {
    root: rootRouteRefPipelines,
  },
});

export const TonkeanCircleciPluginPage = tonkeanCircleciPluginPlugin.provide(
  createRoutableExtension({
    name: 'TonkeanCircleciPluginPage',
    component: () =>
      import('./components/CircleciStatusComponent').then(m => m.CircleciStatusComponent),
    mountPoint: rootRouteRefVersions,
  }),
);

export const TonkeanVersionsPluginPage = tonkeanCircleciPluginPlugin.provide(
    createRoutableExtension({
        name: 'TonkeanVersionsPluginPage',
        component: () =>
            import('./components/CircleciVersionsTableComponent').then(m => m.CircleciStatusAndVersionsPage),
        mountPoint: rootRouteRefPipelines,
    }),
);

export const TonkeanReportsPluginPage = tonkeanCircleciPluginPlugin.provide(
    createRoutableExtension({
        name: 'TonkeanReportsPluginPage',
        component: () =>
            import('./components/ReportsComponent').then(m => m.ReportsPage),
        mountPoint: rootRouteRefReports,
    }),
);

export const TonkeanReleasesPluginPage = tonkeanCircleciPluginPlugin.provide(
  createRoutableExtension({
    name: 'TonkeanReleasesPluginPage',
    component: () =>
      import('./components/CircleciReleasesComponent').then(
        m => m.CircleciReleasesComponent,
      ),
    mountPoint: rootRouteRefReleases,
  }),
);

